module.exports = __webpack_public_path__ + "static/media/hacker.78ec95a7.png";